<div class="user-access-container">
  <header class="user-access-header">
    <div class="section-tabs">
      <div class="section-tab">
        <app-shared-button
          class="section-tab"
          [colour]="'clear'"
          [header]="true"
          [selected]="!byStore"
          (click)="onViewUserClick()">
          <app-icon-person></app-icon-person>
          Users
        </app-shared-button>
        <app-shared-button
          class="section-tab"
          [colour]="'clear'"
          [header]="true"
          [selected]="byStore"
          (click)="onViewStoreClick()">
          <app-icon-store-outline></app-icon-store-outline>
          Stores
        </app-shared-button>
      </div>
    </div>
  </header>
</div>

<div class="user-access-body">
  @if (isLoading) {
    <div class="loading-indicator" aria-live="polite" aria-busy="true">
      <app-shared-loading-progress
        [message]="'Updating staff access…'"
        [presentation]="loadingPresentation">
      </app-shared-loading-progress>
    </div>
  }

  <div class="main-container">
    <aside class="panel panel-list">
      @if (!isLoading) {
        <div class="panel-list-header">
          @if (!byStore) {
            <div class="search-and-filter-div">
              <app-shared-custom-search
                [searchAll]="searchString"
                class="search-bar"
                [placeholder]="'Search for users'"
                (searchChange)="searchUser($event)">
              </app-shared-custom-search>
            </div>
          } @else {
            <app-shared-custom-search
              [searchAll]="storeSearchString"
              class="search-bar-store"
              [placeholder]="'Search for stores'"
              (searchChange)="searchStore($event)">
            </app-shared-custom-search>
          }
        </div>

        <div class="list-scroll">
          @if ((!byStore && fuzzyUsers.length > 0) || byStore) {
            @for (item of (!byStore ? fuzzyUsers : fuzzyStores); track item) {
              <button
                type="button"
                class="list-row"
                [class.list-row-selected]="item === selectedAccordion"
                [class.list-row-store]="byStore"
                [disabled]="byStore && !currentUserAccess.adminAccessStores.includes(item)"
                (click)="(currentUserAccess.adminAccessStores.includes(item) && byStore) || !byStore ? onAccordionSelect(item) : null">
                @if (colleagues[item]?.userData?.pp) {
                  <img
                    [src]="colleagues[item]?.userData?.pp"
                    alt="Profile Picture"
                    class="profile-picture">
                } @else if (!byStore) {
                  <span class="initial-avatar">{{ getUserNameInitials(item) }}</span>
                }
                @if (byStore) {
                  <app-icon-store-outline class="store-list-icon"></app-icon-store-outline>
                }
                <div class="list-row-content">
                  <div class="list-row-title" [class.store-list-item]="byStore">
                    {{ !byStore ? colleagues[item]?.userData?.userName : stores[item] }}
                  </div>
                  @if (!byStore) {
                    <p class="list-row-subtitle">{{ colleagues[item]?.userData?.id }}</p>
                  }
                  @if (!currentUserAccess.adminAccessStores.includes(item) && byStore) {
                    <p class="list-row-warning">You do not have permission to edit this store</p>
                  }
                </div>
                @if (!byStore) {
                  <div class="list-row-trailing">
                    <p class="list-row-meta">{{ getLastSeenDisplayText(colleagues[item]?.lastSeen) }}</p>
                    <div class="list-row-actions">
                      <button
                        type="button"
                        class="icon-inline-button"
                        aria-label="Edit user profile"
                        matTooltip="Edit profile"
                        (click)="$event.stopPropagation(); onUserProfileClick(item)">
                        <app-display-icon
                          [border]="false"
                          [colour]="iconColourEnum.primary"
                          [icon]="icon.pencil">
                        </app-display-icon>
                      </button>
                    </div>
                  </div>
                }
              </button>
            }
          } @else {
            <section class="empty-state">
              <h3>No Users Found</h3>
              <p>It's a bit lonely here — why not add a user?</p>
            </section>
          }
        </div>

        <div class="panel-footer">
          @if (!byStore) {
            <app-shared-button (click)="onAddNewUserClick()">
              <app-icon-person-plus-outline></app-icon-person-plus-outline>
              Add User
            </app-shared-button>
          }
        </div>
      }
    </aside>

    <section class="panel panel-details">
      @if (selectedAccordion) {
        <header class="details-header">
          @if (colleagues[selectedAccordion]?.userData?.pp) {
            <img [src]="colleagues[selectedAccordion]?.userData?.pp" alt="Profile Picture" class="profile-picture">
          } @else if (!byStore) {
            <span class="initial-avatar">{{ getUserNameInitials(selectedAccordion) }}</span>
          }
          <h2 [class.by-store]="byStore">
            {{ byStore ? stores[selectedAccordion] : colleagues[selectedAccordion]?.userData?.userName }}
          </h2>
          <div class="details-header-actions">
            @if (!byStore) {
              <button
                type="button"
                class="icon-inline-button"
                aria-label="Edit user profile"
                matTooltip="Edit profile"
                (click)="onUserProfileClick(selectedAccordion)">
                <app-display-icon
                  [border]="false"
                  [colour]="iconColourEnum.primary"
                  [icon]="icon.pencil">
                </app-display-icon>
              </button>
            }
            <span class="details-count">{{ getUserStoreCount }}</span>
          </div>
        </header>

        <div class="details-body">
          @if (!byStore) {
            @for (storeId of colleaguesStoresSorted[selectedAccordion]; track storeId) {
              @if (currentUserAccess.adminAccessStores.includes(storeId)) {
                <div class="access-row" [class.access-row-deleted]="isDeleted(selectedAccordion, storeId)">
                  <app-display-icon
                    [icon]="icon.infoSlabCircleOutline"
                    [tooltip]="getAccessGroupToolTip()">
                  </app-display-icon>
                  <app-icon-store-outline class="access-row-store-icon"></app-icon-store-outline>
                  <span class="access-row-name">{{ stores[storeId] }}</span>
                  <div class="role-controls" [class.role-controls-modified]="isAccessRowModified(selectedAccordion, storeId)">
                    <app-shared-custom-select
                      (selectionChange)="onRoleSelectChange(selectedAccordion, storeId, $event)"
                      [allowMultiple]="false"
                      [allowSelectAll]="false"
                      [autoSubmitOnSelect]="true"
                      [floatDropdown]="true"
                      [isDisabled]="isDeleted(selectedAccordion, storeId)"
                      [placeholder]="'Select role'"
                      [setOptions]="getRoleSelectOptions(selectedAccordion, storeId)"
                      [showActionButtons]="false"
                      [showChips]="false"
                      [showSearchBar]="false">
                    </app-shared-custom-select>
                  </div>
                  <button
                    type="button"
                    class="icon-action-button"
                    [attr.title]="isAdminRole(selectedAccordion, storeId) ? adminPermissionsTooltip : 'Customise permissions'"
                    [matTooltip]="isAdminRole(selectedAccordion, storeId) ? adminPermissionsTooltip : ''"
                    [disabled]="isDeleted(selectedAccordion, storeId) || isAdminRole(selectedAccordion, storeId)"
                    (click)="onCustomisePermissionsClick(selectedAccordion, storeId)">
                    <app-display-icon
                      [border]="false"
                      [colour]="iconColourEnum.primary"
                      [icon]="icon.pencil">
                    </app-display-icon>
                  </button>
                  @if (!isDeleted(selectedAccordion, storeId)) {
                    <button
                      type="button"
                      class="icon-action-button icon-action-button-danger"
                      aria-label="Remove store access"
                      (click)="onStripUserAccessClick(selectedAccordion, storeId)">
                      <app-icon-delete-outline class="delete-icon"></app-icon-delete-outline>
                    </button>
                  } @else {
                    <button
                      type="button"
                      class="icon-action-button"
                      aria-label="Undo remove store access"
                      (click)="onUndoDeleteClick(selectedAccordion, storeId)">
                      <app-icon-backspace-outline class="undo-icon"></app-icon-backspace-outline>
                    </button>
                  }
                </div>
              }
            }
          } @else {
            @if (storeUsers[selectedAccordion]?.length > 0) {
              @for (userId of storeUsers[selectedAccordion]; track userId) {
                <div class="access-row access-row-user" [class.access-row-deleted]="isDeleted(userId, selectedAccordion)">
                  @if (colleagues[userId]?.userData?.pp) {
                    <img
                      [src]="colleagues[userId]?.userData?.pp"
                      alt="Profile Picture"
                      class="profile-picture">
                  } @else {
                    <span class="initial-avatar">{{ getUserNameInitials(userId) }}</span>
                  }
                  <div class="access-row-user-info">
                    <div class="access-row-user-title">
                      <span>{{ colleagues[userId]?.userData?.userName ?? 'Error fetching user name' }}</span>
                    </div>
                    <p class="list-row-subtitle">{{ userId }}</p>
                  </div>
                  @if (colleagues[userId]?.status) {
                    <span
                      class="status-badge status-badge-row-end"
                      [class.status-badge-pending]="colleagues[userId]?.status === 'PENDING'"
                      [class.status-badge-verified]="colleagues[userId]?.status === 'VERIFIED'"
                      [class.status-badge-expired]="colleagues[userId]?.status === 'EXPIRED'">
                      {{ colleagues[userId]?.status }}
                    </span>
                  }
                  <div class="role-controls" [class.role-controls-modified]="isAccessRowModified(userId, selectedAccordion)">
                    <app-shared-custom-select
                      (selectionChange)="onRoleSelectChange(userId, selectedAccordion, $event)"
                      [allowMultiple]="false"
                      [allowSelectAll]="false"
                      [autoSubmitOnSelect]="true"
                      [floatDropdown]="true"
                      [isDisabled]="isDeleted(userId, selectedAccordion)"
                      [placeholder]="'Select role'"
                      [setOptions]="getRoleSelectOptions(userId, selectedAccordion)"
                      [showActionButtons]="false"
                      [showChips]="false"
                      [showSearchBar]="false">
                    </app-shared-custom-select>
                  </div>
                  <button
                    type="button"
                    class="icon-action-button"
                    [attr.title]="isAdminRole(userId, selectedAccordion) ? adminPermissionsTooltip : 'Customise permissions'"
                    [matTooltip]="isAdminRole(userId, selectedAccordion) ? adminPermissionsTooltip : ''"
                    [disabled]="isDeleted(userId, selectedAccordion) || isAdminRole(userId, selectedAccordion)"
                    (click)="onCustomisePermissionsClick(userId, selectedAccordion)">
                    <app-display-icon
                      [border]="false"
                      [colour]="iconColourEnum.primary"
                      [icon]="icon.pencil">
                    </app-display-icon>
                  </button>
                  @if (!isDeleted(userId, selectedAccordion)) {
                    <button
                      type="button"
                      class="icon-action-button icon-action-button-danger"
                      aria-label="Remove user access"
                      (click)="onStripUserAccessClick(userId, selectedAccordion)">
                      <app-icon-delete-outline class="delete-icon"></app-icon-delete-outline>
                    </button>
                  } @else {
                    <button
                      type="button"
                      class="icon-action-button"
                      aria-label="Undo remove user access"
                      (click)="onUndoDeleteClick(userId, selectedAccordion)">
                      <app-icon-backspace-outline class="undo-icon"></app-icon-backspace-outline>
                    </button>
                  }
                </div>
              }
            } @else {
              <section class="empty-state">
                <h3>No Users Found</h3>
                <p>It's a bit lonely here — why not add a user?</p>
              </section>
            }
          }
        </div>

        <footer class="details-footer">
          @if (!byStore) {
            <app-shared-button
              (click)="addStore()"
              [colour]="'secondary'"
              [disabled]="!canAddStoreToSelectedUser()">
              + Add Store
            </app-shared-button>
          } @else {
            <app-shared-button
              (buttonClicked)="addUser()"
              [colour]="'secondary'"
              [disabled]="!canAddUserToSelectedStore()"
              [title]="isStoreAtUserCapacity() ? 'You have reached the maximum number of users for this store' : ''">
              + Add User
            </app-shared-button>
          }
          @if (haveUsersOrStoresBeenUpdated) {
            <app-shared-button
              (buttonClicked)="discardChanges()"
              [colour]="'secondary'">
              Discard Changes
            </app-shared-button>
          }
          <app-shared-button
            (buttonClicked)="save()"
            [colour]="'success'"
            [disabled]="!haveUsersOrStoresBeenUpdated"
            [fill]="true">
            Save
          </app-shared-button>
        </footer>
      } @else if (fuzzyUsers.length > 0 || byStore) {
        <div class="please-select-overlay">
          <section class="please-select-card">
            <h3>Please select a {{ byStore ? 'store' : 'user' }}</h3>
            <p>No {{ byStore ? 'store' : 'user' }} is selected. Please choose one from the list.</p>
          </section>
        </div>
      }
    </section>
  </div>
</div>
